let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2bcGk")).then(() => parcelRequire('Em5qu'));